// extracted by mini-css-extract-plugin
export default {"container":"AccountMapping_container__5Rr31","header":"AccountMapping_header__6F9Fg","table":"AccountMapping_table__0HYWw","select":"AccountMapping_select__98Zf4"};